import CallIcon from '@mui/icons-material/Call';
import { useTheme } from '@mui/material';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const Call = () => {
  const theme = useTheme();

  return <CallIcon sx={tertiaryHoverSx(theme)} />;
};
